'use strict';

module.exports = {
  element: null
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/autocomplete.js/src/common/dom.js
// module id = 1
// module chunks = 0